import React from 'react';
import { Card, CardBody, CardFooter, CardHeader, Col, Row } from 'reactstrap';
import { VehicleImage } from './VehicleImage';

interface IProps {
    vehicleDetail: IVehicleCatalog,
    drillDownCallback: (vehicleID: number) => void,
}

interface IVehicleCatalog {
    vehicleID: number,
    model: string,
    detailedModel: string,
    modelYear: number,
    classificationName: string,
    allElectricRange: number,
    fullRange: number,
    vehicleTypeName: string,
    vehicleSecondaryTypeName: string,
    isAvailable: boolean,
    isBuyAmericaCompliant: boolean,
    vehicleDriveTrainName: string,
    manufacturerName: string,
    expectedAvailability: number,
    batterySize: number,
    grossVehicleWeightRating: string,
    grossCarryingWeightRating: number,
    vehicleFHWAClassTypeName: string,
    msrp: number,
    seatingCapacity: number,
    citykWh100mi: number,
    highwaykWh100mi: number,
    combinedkWh100mi: number,
    imageID: string,
    imagePath: string,
    vehicleTypeImageID: string,
    vehicleTypeImagePath: string,
    manufacturerWebsiteURL: string,
    vehicleDriveTrainDescription: string
}

const formatNumber = (value: number) => {
    if (value) {
        var num = value;
        return num.toLocaleString();
    } else {
        return value;
    }
}

export const DetailCard = ({ vehicleDetail, drillDownCallback }: IProps) => {

    return (
        <Card>
            <CardHeader>
                <Row>
                    <Col lg={9} md={9} sm={10} xs={10} className="col">{vehicleDetail.manufacturerName}&nbsp;{vehicleDetail.detailedModel}</Col>
                    <Col lg={3} md={3} sm={2} xs={2} className="text-align-right">{vehicleDetail.modelYear}</Col>
                </Row>
            </CardHeader>
            <CardBody>
                <VehicleImage vehicleImagePath={vehicleDetail.imagePath} vehicleTypeImagePath={vehicleDetail.vehicleTypeImagePath} vehicleMakeModel={`${vehicleDetail.manufacturerName} ${vehicleDetail.detailedModel}`} showLoadingSymbol={false} />
                <Row className="stickToBottom">
                    <Col lg={6} md={6} sm={6} xs={6} className="text-align-center details small"><strong>MSRP:</strong>&nbsp;{vehicleDetail.msrp ? '$' + formatNumber(vehicleDetail.msrp) : 'Coming Soon'}</Col>
                    <Col lg={6} md={6} sm={6} xs={6} className="text-align-center details small"><strong>Range:</strong>&nbsp;{vehicleDetail.fullRange}</Col>
                </Row>
            </CardBody>
            <CardFooter onClick={() => drillDownCallback(vehicleDetail.vehicleID)}>
                <svg width="12" height="12" viewBox="0 0 14 14" fill="white" xmlns="http://www.w3.org/2000/svg">
                    <path fillRule="evenodd" clipRule="evenodd" d="M13.0099 6.80091L6.94922 12.8616L5.88856 11.8009L10.1386 7.55091L0.949219 7.55091L0.949219 6.05091L10.1386 6.05091L5.88856 1.76354L6.94922 0.702881L13.0099 6.80091Z" fill="white"/>
                </svg>
                <span>GO</span>
            </CardFooter>
        </Card>
    );
}
